// extracted by mini-css-extract-plugin
export default {"toolbar-menu-btn":"ToolbarMenuButton_toolbar-menu-btn__At23p"};